import { captureException } from "@sentry/react";

export function reportError(path: string, message: string, error: Error) {
  console.error(message, error);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  captureException(new Error(`[${path}] - ${message}`, { cause: error } as ErrorOptions));
}
